"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDivider = exports.CloseButtonContainer = exports.Footer = exports.StyledTitle = exports.Title = exports.SubTitle = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
exports.SubTitle = styled_components_1.default.div `
  ${(props) => props.theme.typography.variants.primary.main};
  margin-top: 16px;
`;
exports.Title = styled_components_1.default.div `
  ${(props) => props.theme.typography.variants.primary.large};
`;
exports.StyledTitle = (0, styled_components_1.default)(exports.Title) `
  padding-right: 24px;
  ${(props) => props.renderLargeSubTitle &&
    (0, styled_components_1.css) `
      margin-top: 24px;
    `}
`;
exports.Footer = styled_components_1.default.div `
  padding: 24px 16px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;

  button {
    flex-grow: 1;
    margin-bottom: 12px;
  }
`;
exports.CloseButtonContainer = styled_components_1.default.div `
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 100;
`;
exports.StyledDivider = (0, styled_components_1.default)(Divider_1.default) `
  &.MuiDivider-root {
    margin-top: 24px;
  }
`;
//# sourceMappingURL=styles.js.map